export const planQueryKeys = {
  GET_PLANS_TREE_QUERY: 'getPlansTreeQuery',
  GET_PLANS_TREE_INFINITY_QUERY: 'getPlansTreeInfinityQuery',
  GET_PLANS_CHILDREN_TREE_QUERY: 'getPlansChildrenTreeQuery',
  ARCHIVE_URL: 'archiveUrl',
  INDICES: 'indices',
  GET_PLAN_DETAILS: 'getPlanDetails',
  GET_PLAN_FOLDER_DETAILS: 'getPlanFolderDetails',
  GET_RELATIVE_PLAN_PATH: 'getRelativePlanPath'
}

export const planMutationKeys = {
  UPDATE_PLAN_DETAILS: 'updatePlanDetails',
  UPDATE_PLAN_FOLDER_DETAILS: 'updatePlanFolderDetails',
  CREATE_PLAN_FOLDER: 'createPlanFolder',
  MOVE_PLANS_AND_FOLDERS: 'movePlansAndFolders',
  CHECK_CHILDREN_NAME_IS_AVAILABLE: 'checkChildrenNameIsAvailable',
  DELETE_PLAN_FOLDER_MUTATION: 'deletePlanFolderMutation',
  UPDATE_BULK_PLANS_MUTATION: 'updateBulkPlansMutation',
  EXPORT_PLAN_MUTATION: 'exportPlanMutation'
}

export const plansApiTypeOptions = {
  PROJECTS: 'projects',
  FOLDERS: 'folders'
}

export const planTreeTypeFilterOptions = {
  ALL: 'All',
  FOLDERS: 'Folders',
  PLANS: 'Plans'
}
